import { QueryKey } from '@tanstack/react-query';
import Switch from 'components/switch/Switch';
import {
  IntegrationStatus,
  InternalIntegrationSetting,
} from 'models/InternalIntegrationSetting';
import useDisableAgencyIntegrationModal from 'pages/channels/components/modals/disableAgencyChannel/useDisableAgencyChannelModal';
import useEnableIntegrationMutation from 'pages/integrations/hooks/useEnableIntegrationMutation';
import { IntegrationMutationLevel } from 'pages/integrations/hooks/useDisableIntegrationMutation';

const LegacySwitch = ({
  integration,
  queryKey,
}: {
  integration: InternalIntegrationSetting;
  queryKey: QueryKey;
}) => {
  const { enableIntegration } = useEnableIntegrationMutation();
  const { openDisableAgencyIntegrationModal } =
    useDisableAgencyIntegrationModal();

  const { status } = integration.agencySettings;
  const isActive = status === IntegrationStatus.ACTIVE;

  const handleLegacyV2Toggle = () => {
    if (isActive) {
      openDisableAgencyIntegrationModal({
        integration,
        queryKey,
      });
    } else {
      enableIntegration({
        level: IntegrationMutationLevel.AGENCY,
        enumId: integration.enumId,
        queryKey,
      });
    }
  };

  return (
    <Switch
      data-testid="channel-status-switch"
      className="small"
      checked={isActive}
      onClick={(e) => {
        e.stopPropagation();
        handleLegacyV2Toggle();
      }}
    />
  );
};

export default LegacySwitch;
